export default {
  copy: 'Kopírovať do schránky',
};
